import React, { useEffect, useRef, useCallback, useState, useMemo } from 'react';

import '../BrowserTop/BrowserTop.css';
import './MobileTop.css';
import { ReactComponent as CopyLinkSVG } from '../Images/buttons/linkCopyGray.svg';
import { ReactComponent as JoinLeftSVG } from '../Images/buttons/joinButtonLeft.svg';
import { ReactComponent as HatenaSVG } from '../Images/buttons/hatenaButton.svg';
import { ReactComponent as LiveIconSVG } from '../Images/buttons/liveIcon.svg';
import { ReactComponent as LogoSVG } from '../Images/header/logoBlack.svg';
import { ReactComponent as SettingSVG } from '../Images/header/settingBlack.svg';
import { ReactComponent as CloseWhiteSVG } from '../Images/buttons/windowCloseButtonWhite.svg';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import {
  isAuthAtom,
  topMessageAtom,
  isAuthLoadedAtom,
  pageAtom,
  myNftAtom,
  displayNameAtom,
} from '../../State';
import DataModel from '../Util/DataModel';
import AuthCheck from '../../AuthCheck';
import ShowMessage from '../Header/ShowMessage';
import ElectronEmail from './ElectronEmail';
import ElectroJoin from './ElectronJoin';
import FaceImage from '../Setting/FaceImage';
import { useTranslation } from 'react-i18next';
import AddLive from '../BrowserTop/AddLive';
import Meeting from '../../Meeting';
import { useNavigate } from 'react-router-dom';
import MobileSetting from './MobileSetting';
import KUTE from 'kute.js';
import Header from '../Header/Header';
import { getImagePath } from '../Util/utils';

export default ({ f7router }) => {
  const { t } = useTranslation();
  const navigate = useNavigate(); //リダイレクト用

  //Recoil系
  const [authState, setAuthState] = useRecoilState(isAuthAtom);
  const [isAuthLoadedState, setIsAuthLoadedState] = useRecoilState(isAuthLoadedAtom);
  const setTopMessageState = useSetRecoilState(topMessageAtom);
  const [pageState, setPageState] = useRecoilState(pageAtom);
  const [myNftState, setMyNftState] = useRecoilState(myNftAtom);
  const [displayNameState, setDisplayNameState] = useRecoilState(displayNameAtom);

  //その他
  const [isLoadedState, setIsLoadedState] = useState(false);
  const [meetingIDState, setMeetingIDState] = useState(null);
  const [showJoin, setShowJoin] = useState(false);
  const [hatenaState, setHatenaState] = useState(false);
  const [showLive, setShowLive] = useState(false);
  const [showMeeting, setShowMeeting] = useState(false);
  const [showFace, setShowFace] = useState(false);
  const [showCreateLive, setShowCreateLive] = useState(false);
  const [showLiveButton, setShowLiveButton] = useState(false);
  const [showRecordedList, setShowRecordedList] = useState(false);
  const liveRoomID = useRef(null);

  //設定型
  const [drawerState, setDrawerState] = useState(false);
  const [showFormState, setShowFormState] = useState(false);

  //認証
  useMemo(() => {
    if (localStorage.getItem('isAuth') != null && localStorage.getItem('isAuth')) {
      setAuthState(true);
    }

    //初期化
    init();
  }, []);

  function init() {
    if (localStorage.getItem('displayName') != null) {
      setDisplayNameState(localStorage.getItem('displayName'));
    }
  }

  useEffect(() => {
    //ライブ状況取得
    liveCheck();
  }, [showLive]);

  //liveモードの状態を確認
  async function liveCheck() {
    var roomID = await DataModel.checkLiveStatus();
    if (roomID != null) {
      liveRoomID.current = roomID;
      setShowLiveButton(true);
    } else {
      setShowLiveButton(false);
    }
  }

  useEffect(() => {}, [isAuthLoadedState]);

  useEffect(() => {
    if (authState) {
      getMeetingID();
    }
  }, [authState]);

  useEffect(() => {
    showProfileImage();
  }, [myNftState]);

  async function getMeetingID() {
    if (localStorage.getItem('meetingID') == null || localStorage.getItem('meetingID') == '') {
      const meetingID = await DataModel.getUserData('meetingID');
      if (meetingID != null) {
        //ローカルストレージに保存
        localStorage.setItem('meetingID', meetingID);

        //ミーティングIDを設定
        setMeetingIDState(meetingID);

        //ローディング完了
        //setIsLoadedState(true);
      }
    } else {
      //ミーティングIDを設定
      setMeetingIDState(localStorage.getItem('meetingID'));

      //ローディング完了
      //setIsLoadedState(true);
    }
  }

  function showProfileImage() {
    if (localStorage.getItem('imageURL') != null) {
      setMyNftState(localStorage.getItem('imageURL'));
    } else {
    }
  }

  //新しいミーティン
  const newMeeting = async () => {
    //navigate('/' + meetingIDState);
    setShowMeeting(true);
  };

  //参加
  const joinMeeting = async () => {
    setShowJoin(true);
  };

  //顔をタップ
  const tapFace = async () => {
    //navigate('/face');
    setShowFace(true);
  };

  //クリップボードにコピー
  const copyURL = () => {
    const url = 'https://faceless.ooo/' + meetingIDState;
    navigator.clipboard.writeText(url).then(
      function () {
        setTopMessageState({ type: 'copied', message: t('top.Copied Successfully') });
      },
      function (err) {},
    );
  };

  //新しいミーティング
  const showLiveForm = async () => {
    setShowLive(true);
  };

  const showSetting = async () => {
    // const url = await window.myapi.getURL('setting');
    // window.open(url, '_blank');
  };

  const hatenaOver = async () => {
    setHatenaState(true);
  };

  const hatenaOut = async () => {
    setHatenaState(false);
  };

  const handleClickOpen = () => {
    setShowFormState(true);
  };

  useEffect(() => {
    if (showMeeting) {
      let kute = KUTE.to(
        '#meetingAnimWrap',
        { top: '0%' },
        {
          duration: 300,
          easing: 'easingCubicOut',
          onComplete: () => {
            navigate('/' + meetingIDState);
          },
        },
      );
      kute.start();
    }
  }, [showMeeting]);

  useEffect(() => {
    if (showFace) {
      let kute = KUTE.to(
        '#meetingAnimWrap',
        { top: '0%' },
        {
          duration: 300,
          easing: 'easingCubicOut',
          onComplete: () => {
            navigate('/face');
          },
        },
      );
      kute.start();
    }
  }, [showFace]);

  return (
    <>
      {/* 認証 */}
      <AuthCheck />

      {/* 設定 */}
      <MobileSetting
        showFormState={showFormState}
        setShowFormState={setShowFormState}
        drawerState={drawerState}
        setDrawerState={setDrawerState}
      />

      {/* ログイン画面 */}
      {authState == false && <ElectronEmail />}

      {/* 参加画面画面 */}
      {showJoin && <ElectroJoin setShowJoin={setShowJoin} />}

      {/* ヘッダーのメッ */}
      <ShowMessage />

      {(showMeeting || showFace) && (
        <>
          <div id="meetingAnimWrap">
            <div id="meetingAnimInside">
              <div className="isMobileDummy">
                <header>
                  <div id="hairCheckClose">
                    <CloseWhiteSVG />
                  </div>
                  <div id="electronHeaderLogo">
                    <img src={getImagePath() + '/header/logoDummyLeft.svg'} />
                  </div>
                </header>
              </div>
            </div>
          </div>
        </>
      )}

      {/* ライブ追加画面 */}
      {showLive && <AddLive setShowLive={setShowLive} roomID={liveRoomID.current} />}

      <div id="isMobile">
        <div id="electronWrap">
          <div id="electronTop">
            <div id="electronHeader">
              <div id="electronTopDrag"></div>
              <div id="electronHeaderImage">
                <LogoSVG />
              </div>

              <div
                id="electronHeaderSetting"
                onClick={() => {
                  setDrawerState(true);
                }}>
                <SettingSVG />
              </div>
            </div>
            <div id="electronWrapImage">
              <FaceImage myNftState={myNftState} tapFace={tapFace} />
            </div>

            <div id="electronTopName" onClick={handleClickOpen}>
              {displayNameState}
            </div>

            <div id="topIDArea">
              <div id="topIDTitleWrap">
                {hatenaState && (
                  <div id="topIDHatenaDetail">
                    {t('mypage.This meeting URL is yours which never changed until you request')}
                  </div>
                )}
                <div id="topIDTitle">{t('mypage.Your Meeting URL')}</div>
                <div id="topIDHatena" onMouseEnter={hatenaOver} onMouseLeave={hatenaOut}>
                  <HatenaSVG />
                </div>
              </div>
              <div id="topIDWrap" onClick={copyURL}>
                {/* <div id="topID">{meetingIDState == null ? '--- --- ---' : meetingIDState}</div> */}
                <div id="topID">
                  {meetingIDState == null
                    ? '--- --- --- '
                    : 'https://faceless.ooo/' + meetingIDState}
                </div>
                <div id="topIDCopy">
                  <CopyLinkSVG />
                </div>
              </div>
            </div>

            <div id="topButtonWrap">
              <button id="newMeetingButton" onClick={newMeeting} className="topIDITem">
                <div id="newMeetingLeft">
                  <JoinLeftSVG />
                </div>
                <div>{t('mypage.Start Meeting')}</div>
              </button>

              <button className="liveButton" onClick={showLiveForm} style={{ marginTop: '20px' }}>
                <div className="liveButtonLeft">
                  <LiveIconSVG />
                </div>
                <div>{t('mypage.Start Live')}</div>
              </button>

              <div id="joinText" onClick={joinMeeting}>
                {t('mypage.Join Meeting')}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
